export const PAGE_COMMENTS_TABLE = "page_comments"